import { createUseStyles } from 'react-jss'
import { BLACK, BLUE, WHITE } from '@omnilert/components'


export default createUseStyles({
  expandButton: {
    background: 'transparent',
    border: 'none',
    color: BLUE,
    fontSize: '14px',
    marginBottom: '10px',
    padding: 0,
    marginTop: 0,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  files: {
    display: ({ isExpanded }) => isExpanded ? 'flex' : 'none',
    justifyContent: 'flex-start',
    marginBottom: '5px'
  },
  imageWrapper: {
    justifyContent: 'flex-start',
    flexDirection: 'column',
    padding: '0 22px 5px',
    '@media (max-width: 667px)': {
      paddingLeft: '15px'
    }
  },
  imageContainer: {
    display: 'flex',
    height: '100px',
    width: '100px'
  },
  image: {
    borderRadius: '5px',
    backgroundColor: BLACK,
    height: '90px',
    border: ['2px', 'solid', WHITE],
    boxShadow: '0px -1px 23px -9px rgba(0,0,0,0.74)',
    objectFit: 'cover',
    width: '100%'
  },
  videoContainer: {
    display: 'flex',
    height: '100px',
    objectFit: 'cover',
    width: '100px'
  },
  video: {
    borderRadius: '5px !important',
    border: ['3px', 'solid', 'var(--file-upload--border)'],
    height: '90px',
    width: '90px',
    backgroundColor: BLACK,
    boxShadow: '0px -1px 23px -9px rgba(0,0,0,0.74)'
  }
})
